import { THEME } from '../overview/boardStyles';
/** Shared contrast and interaction states on the Finance/Payroll dark surfaces. */
export const financePanelSx = {
  color: THEME.white,
  '& .MuiInputBase-root, & .MuiInputLabel-root, & .MuiSelect-icon': { color: THEME.white },
  '& .MuiOutlinedInput-notchedOutline': { borderColor: THEME.pink },
  '& input[type="date"]': { colorScheme: 'dark' },
  '& .MuiTableBody-root .MuiTableCell-root': { color: THEME.white, borderColor: THEME.pinkSoft },
  '& .MuiTableRow-hover:hover': { bgcolor: THEME.pinkTint },
  '& .MuiButton-root.Mui-disabled': { color: THEME.faint, borderColor: THEME.pinkSoft },
  '& .MuiPaginationItem-root': { color: THEME.white },
  '& .MuiPaginationItem-root.Mui-selected': { bgcolor: THEME.pinkTint },
};
